"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestToolInstallationUserError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const lodash_1 = require("lodash");
const depsError_1 = require("../../../../common/deps-checker/depsError");
const localizeUtils_1 = require("../../../../common/localizeUtils");
const errorCode = "TestToolInstallationError";
const messageKey = "driver.prerequisite.error.testToolInstallationError";
class TestToolInstallationUserError extends teamsfx_api_1.UserError {
    constructor(actionName, error, helpLink) {
        super({
            source: lodash_1.camelCase(actionName),
            name: errorCode,
            message: error instanceof depsError_1.DepsCheckerError ? error.message : localizeUtils_1.getDefaultString(messageKey),
            displayMessage: error instanceof depsError_1.DepsCheckerError ? error.message : localizeUtils_1.getLocalizedString(messageKey),
            helpLink: helpLink,
        });
    }
}
exports.TestToolInstallationUserError = TestToolInstallationUserError;
//# sourceMappingURL=testToolInstallationUserError.js.map